<script lang="ts">
    import {guiCreatorDataStore} from '../../stores/guiCreatorData';
    import {GUICreatorData} from '../../stores/types';
    import PageDeleteConfirmation from "./PageDeleteConfirmation.svelte";

    let availablePages = [];
    let currentPage = '';
    let currentEditedPage = '';
    let currentEditedPageValue = '';
    let newPageInCreation = false;
    let newPageValue = '';
    let mouseOverPageDeleteBtn = false;
    let uiElementsCount = 0;
    let timeoutId;
    let longPressPage = null;

    guiCreatorDataStore.subscribe((guiCreatorData: GUICreatorData) => {
        availablePages = Object.keys(guiCreatorData.pages);
        currentPage = guiCreatorData.currentPage;
        if (guiCreatorData.pages[currentPage]) {
            uiElementsCount = Object.keys(guiCreatorData.pages[currentPage]).length;
        }
    });

    function changePageTo(newPageName: string) {
        if (timeoutId !== null) {
            guiCreatorDataStore.setCurrentPage(newPageName);
        }
    }

    function startLongPressTimer(page: string) {
        longPressPage = page;
        timeoutId = setTimeout(() => {
            if (longPressPage !== null) {
                currentEditedPageValue = longPressPage;
                currentEditedPage = longPressPage;
                mouseOverPageDeleteBtn = false;
            }
        }, 500);
    }

    function cancelLongPressTimer() {
        longPressPage = null;
        clearTimeout(timeoutId);
    }

    function updatePage(oldPage, newPage) {
        if (newPage.length > 0 && oldPage !== newPage) {
            guiCreatorDataStore.updatePage(oldPage, newPage);
        }
        currentEditedPage = null;
    }

    function onEditedPageKeyDown(event, page, newPageValue) {
        if (event.key === 'Enter') {
            updatePage(page, newPageValue);
        }
    }

    function onNewPageKeyDown(event, newPageValue) {
        if (event.key === 'Enter') {
            createNewPage(newPageValue);
        }
    }

    function onNewPage() {
        newPageValue = '';
        newPageInCreation = true;
    }

    function createNewPage(newPageValue) {
        if (newPageValue.length > 0) {
            guiCreatorDataStore.addPage(newPageValue);
        }
        newPageInCreation = false;
    }
</script>
<div class="border border-b-slate-200">
    <PageDeleteConfirmation selectedPageName="{currentEditedPage}"></PageDeleteConfirmation>
    <div class="tabs " id="ui-editor-pages-bar">

        {#each availablePages as page (page)}
            {#if (page !== currentEditedPage)}
                <a class="tab tab-lifted {page === currentPage ? 'tab-active' : ''}"
                   on:mousedown={() => startLongPressTimer(page)} on:mouseup={cancelLongPressTimer}
                   on:mouseout={cancelLongPressTimer} on:click={() => changePageTo(page)}>{page}</a>
            {:else }
                <div class="tab tab-lifted">
                    <input id="pageUpdateInput"
                           bind:value="{currentEditedPageValue}" type="text" autofocus
                           on:blur={() => !mouseOverPageDeleteBtn ? updatePage(page, currentEditedPageValue) : null}
                           on:keypress|stopPropagation={() => null}
                           on:keydown={(event) => onEditedPageKeyDown(event, page, currentEditedPageValue)}/>
                    <label class="btn btn-square btn-sm btn-error modal-button page-delete-btn"
                           for="page-deletion-confirmation"
                           on:mouseleave={() => mouseOverPageDeleteBtn = false}
                           on:mouseenter={() => mouseOverPageDeleteBtn = true}>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                             stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </label>
                </div>
            {/if}

        {/each}
        {#if (newPageInCreation)}
            <input id="newPageInput" class="tab tab-lifted" bind:value="{newPageValue}" type="text" autofocus
                   on:blur={() => createNewPage(newPageValue)} on:keypress|stopPropagation={() => null}
                   on:keydown={(event) => onNewPageKeyDown(event, newPageValue)}/>
        {:else}
            <a class="tab tab-lifted" on:click={onNewPage}>+</a>
        {/if}
    </div>
</div>
<style>
    #ui-editor-pages-bar {
        width: 100%;
    }
</style>
